import { ExternalAccounts } from '@unistocks/features/external-accounts/external-accounts';
import { t } from '@unistocks/localization';
import Head from 'expo-router/head';

export default function ExternalAccountsScreen() {
  return (
    <>
      <Head>
        <title>{t('::ExternalAccounts')}</title>
      </Head>
      <ExternalAccounts />
    </>
  );
}
